import React from "react";
import "./App.css";
 
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SideBar from "./Pages/Sidebar";
import AppRoutes from "./Pages/Routes/AppRoutes";
 
const App=()=> {  
  return (
    <div className="App">
 
      {localStorage.getItem("islogedin") === "true"  ?
        <SideBar />
        : (
          <AppRoutes />
        )}
      {/* <AppRoutes/> */}
      <ToastContainer
        position="bottom-right"
        autoClose={5000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
 
    </div>
  );
}
 
export default App;